import classNames from "classnames";
import { useFormContext } from "react-hook-form";
import FormItem from "./utils/FormItem";

const SingleLineField = ({
  label = "",
  top = false,
  htmlfor,
  required = false,
  autoFocus = false,
  type = "text",
  disabled = false,
  placeholder = "",
  maxLetters = "",
  className = "",
  rules = {},
  footer = <></>
}) => {
  const {
    register,
    watch,
    formState: { errors },
  } = useFormContext();

  if (!register) {
    throw new Error("No form content and no register passed");
  }

  const htmlFor = htmlfor ? htmlfor : label;

  const get = (obj, path) => {
    if (!path) return undefined;
    return path.split('.').reduce((o, k) => (o ? o[k] : undefined), obj);
  };

  const fieldError = get(errors, htmlfor);
  const error = fieldError?.type !== "required" ? fieldError?.message : null;
  const currentValue = watch ? watch(htmlfor) : undefined;
  const hasValue = !(currentValue === undefined || currentValue === null || currentValue === '');
  const showRequired = !!required && (!hasValue || !!fieldError);

  const input = <>
    <input
      type={type}
      name={label}
      id={htmlFor}
      disabled={disabled}
      placeholder={placeholder}
      maxLength={maxLetters}
      className={classNames(
        "max-w-lg block w-full shadow-sm sm:max-w-xs sm:text-sm border-gray-300 focus:ring-indigo-500 focus:border-indigo-500 rounded-md",
        {
          "border-red-300 focus:ring-red-500 focus:border-red-500": !!error,
        },
        className
      )}
      autoFocus={autoFocus}
      {...register(htmlFor, {
        required: required,
        valueAsNumber: type === "number",
        ...rules,
      })}
    />
    {error && <span className="text-red-500">{error}</span>}
    {footer}
  </>

  if (label) {
    return <FormItem
      top={top}
      label={label}
      required={showRequired}
    >
      {input}
    </FormItem>
  }
  
  return input

};
export default SingleLineField;
